import React from "react";
import NavHeader from "../components/NavHeader";
import { HStack, Heading, Icon, SimpleGrid, VStack } from "@chakra-ui/react";
import { BookOpenText, CirclesFour, Hash } from "@phosphor-icons/react";
import BlogMenuItem from "../components/blogComponents/BlogMenuItem";
import { Link } from "react-router-dom";

export default function Blog() {
  return (
    <>
      <NavHeader label="Blog" />

      <VStack flex={1} align={"stretch"} p={5}>
        <SimpleGrid columns={[1, 2, 3, null, 4]} color={"white"} gap={4}>
          <BlogMenuItem
            border={"2px solid var(--p500)"}
            color={"p.500"}
            _hover={{ bg: "p.500", color: "white" }}
            as={Link}
            to={"/blog/post"}
          >
            <HStack>
              <Icon as={BookOpenText} fontSize={50} weight="fill" />
            </HStack>

            <Heading size={"md"}>BLOG POST</Heading>
          </BlogMenuItem>

          <BlogMenuItem
            border={"2px solid #805AD5"}
            color={"purple.500"}
            _hover={{ bg: "purple.500", color: "white" }}
            as={Link}
            to={"/blog/kategori"}
          >
            <HStack>
              <Icon as={CirclesFour} fontSize={50} weight="fill" />
            </HStack>

            <Heading size={"md"}>KATEGORI</Heading>
          </BlogMenuItem>

          <BlogMenuItem
            border={"2px solid black"}
            color="black"
            _hover={{ bg: "black", color: "white" }}
          >
            <HStack>
              <Icon as={Hash} fontSize={50} weight="fill" />
            </HStack>

            <Heading size={"md"}>TAGS</Heading>
          </BlogMenuItem>
        </SimpleGrid>
      </VStack>
    </>
  );
}
